import { Alert, Typography, Button, Space, ConfigProvider } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.less';

const GDPRPopup: React.FC = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem('gdpr'));
  const { t } = useTranslation(['resource']);

  const closePopup = (result: string) => {
    // Save accept or reject to local storage
    localStorage.setItem('gdpr', result);
    setVisible(false);
  };

  return visible ? (
    <Alert
      banner
      className={styles.gdprPopup}
      description={
        <ConfigProvider
          theme={{
            components: {
              Button: {
                contentFontSizeLG: 20,
                controlHeightLG: 46,
              },
            },
          }}
        >
          <Typography.Paragraph className={styles.text}>
            {t(
              'Accept all cookies to enable personalization, analytics, and ads, or click "No, Thanks" to opt out.',
            )}
          </Typography.Paragraph>
          <Space>
            <Button
              shape='round'
              size='middle'
              onClick={() => closePopup('accept')}
              className={styles.comfirmBtn}
            >
              {t('Accept All Cookies')}
            </Button>
            <Button
              size='middle'
              type='link'
              onClick={() => closePopup('reject')}
              className={styles.rejectBtn}
            >
              {t('No, thanks')}
            </Button>
          </Space>
        </ConfigProvider>
      }
      showIcon={false}
      type='info'
      closable={false}
    />
  ) : null;
};

export default GDPRPopup;
